import React from 'react'
import { APIClient } from '@/services'
import { ScoreHeader, ScoreModal, useScoreModal } from '../Organisations'
import { ScoresContext } from './context'
import { OrgReviewButtons } from '../Organisation'
import { View } from '..'

import { PerTopicEngagementScore } from '../Organisations/PerTopicEngagementScore'

export const IndustryScoreOverview = () => {
  const { industry } = ScoresContext.useIndustrySelector()

  const profileIndustry = ScoresContext.useScoresContext(c => c.profile?.data?.organization?.category?.slug)

  const scoreModal = useScoreModal(false)

  const industryQuery = APIClient.Organisations.useIndustry(industry)

  return <>
    <View variants={['column', 'gap:2', 'alignCenter', 'fullWidth']}>
      <ScoreHeader />
      <PerTopicEngagementScore
        industry={industryQuery.industry}
        onExpand={(topic) => {
          scoreModal.toggle(true, {
            topicId: topic?.value,
          })
        }}

      />
      <OrgReviewButtons isMyOrganisation={profileIndustry === industry}/>
    </View>
    <ScoreModal visible={scoreModal.visible} toggle={scoreModal.toggle} industryId={industry} topicId={scoreModal.props.topicId} />
  </>
}
